import {ValueObject} from '@s-ui/domain'

export class DatalistItemFormValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.text
   * @param {String} params.value
   * */
}
